import { graphql, useStaticQuery } from "gatsby"
import { BrandData } from "../components/core/brand"

export interface Page {
  title: string,
  langKey: string,
  slug: string
}

export interface Company {
  tel: string;
}

export interface NavigationData {
  pages: Page[];
  brand: BrandData;
  company: Company;
}


export const useNavigationData: () => NavigationData = () => {
  const { allSitePage, brand, site } = useStaticQuery<any>(
    graphql`
        query NavigationData {
            allSitePage(filter: {pluginCreator: {name: {eq: "gatsby-plugin-mdx"}}, context: {frontmatter: {footer: {ne: true}}}}, sort: {fields: context___frontmatter___weight}) {
                nodes {
                    context {
                        langKey
                        slug
                        frontmatter {
                            title
                        }
                    }
                }
            }
            brand:   file(relativePath: {eq: "logo.svg"}) {
                name
                publicURL
            }
            site {
                siteMetadata {
                    company {
                        tel
                    }
                }
            }
        }
    `
  )

  const company = site.siteMetadata.company

  const pages: Page[] = allSitePage.nodes.map(node => (
    {
      title: node.context.frontmatter.title,
      langKey: node.context.langKey,
      slug: node.context.slug
    } as Page)
  )

  return { pages, brand, company }
}
